module.exports = __webpack_public_path__ + "static/img-hero-our-story-43d562fe2c32ca6fd51f3455585fce81.jpg";